import React from "react";

export const ChartSkeleton = () => (
  <div className="flex items-center justify-center h-[400px] w-full">
    <div className="w-full h-[300px] BookEZ_card_bg_secondary_light rounded-lg animate-pulse relative overflow-hidden"></div>
  </div>
);
